module.exports = __webpack_public_path__ + "static/media/LemonBand.e6370d81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/IoT/LemonBand.png
// module id = 469
// module chunks = 0